import isPermissionEnabled from "common/isPermissionEnabled"
import Breadcrumbs from "components/Common/Breadcrumb"
import DeleteModal from "components/Common/DeleteModal"
import Filters from "components/Common/Filters"
import Paginations from "components/Common/Paginations"
import { filters } from "components/Common/constants"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import Switch from "components/Shared/Switch"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { ShimmerSimpleGallery } from "react-shimmer-effects"
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap"
import {
  deletePromotion,
  getAllPromotions,
  updatePromotionStatus,
} from "store/actions/promotionsAction"
import { showAlert } from "store/reducers/alertReducer"
import SensitiveActionOtpModal from "components/Shared/SensitiveActionOtpModal"
import useSensitiveAction from "hooks/useSensitiveAction"
import { SENSITIVE_MODULES } from "helpers/sensitiveActionModules"

const Promotions = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Discounts List | Sign Burger")
  const dispatch = useDispatch()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const pageNumber = parseInt(searchParams.get("page")) || 1
  const [searchTerm, setSearchTerm] = useState(searchParams.get("search") || "")
  const [selectedFilters, setSelectedFilters] = useState({
    status: parseInt(searchParams.get("status") || "2"),
    sortOrder: parseInt(searchParams.get("sortOrder") || "2"),
  })
  const navigate = useNavigate()
  const {
    loading,
    itemsPerPage,
    totalCount,
    totalPages,
    currentPage,
    isUpdating,
    isLoading,
    promotions,
  } = useSelector(state => state.Promotions)

  const { userRole, accountType } = useSelector(state => state.Login)

  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    create: null,
    edit: null,
    delete: null,
  })

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      14,
      "promotion_1",
      accountType
    )
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      14,
      "promotion_2",
      accountType
    )
    const isPermissionEdit = isPermissionEnabled(
      userRole,
      14,
      "promotion_3",
      accountType
    )
    const isPermissionDelete = isPermissionEnabled(
      userRole,
      14,
      "promotion_4",
      accountType
    )
    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setUsersPermissions({
      list: isPermissionList,
      create: isPermissionCreate,
      edit: isPermissionEdit,
      delete: isPermissionDelete,
    })
  }, [userRole])

  useEffect(() => {
    fetchAllPromotions()
  }, [])

  const fetchAllPromotions = () => {
    const { status, sortOrder } = selectedFilters

    const payload = {
      perPage: itemsPerPage,
      pageNo: pageNumber,
      status: status,
      orderBy: sortOrder,
      keyword: searchTerm,
    }
    dispatch(getAllPromotions(payload))
    setIsApiCalled(true)
  }

  const [selectedId, setSelectedId] = useState(null)
  const [itemIdToDelete, setItemIdToDelete] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [isApiCalled, setIsApiCalled] = useState(false)

  const submitPromotionActionWithOtp = (data, actionOtp) => {
    const { kind } = data

    if (kind === "STATUS") {
      return dispatch(
        updatePromotionStatus({
          id: data.id,
          status: data.status === 1 ? "0" : "1",
          actionOtp,
        })
      ).then(action => {
        const { statusCode, status, msg } = action?.payload || {}
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setSelectedId(null)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
        return action
      })
    }

  }

  const { startSensitiveAction, modalProps, isActionBusy } = useSensitiveAction({
    module: SENSITIVE_MODULES.PROMOTION,
    onSubmitWithOtp: submitPromotionActionWithOtp,
  })

  const handleFilterChange = (selectedValue, filterName) => {
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: selectedValue,
    }))
  }
  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }

  const fetchPromotions = (page = 1) => {
    const { status, sortOrder } = selectedFilters

    const searchParams = new URLSearchParams()
    searchParams.set("search", searchTerm)
    searchParams.set("status", status.toString())
    searchParams.set("sortOrder", sortOrder.toString())
    searchParams.set("page", page.toString())

    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      status: Number(status),
      orderBy: Number(sortOrder),
      keyword: searchTerm || "",
    }

    dispatch(getAllPromotions(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/discounts?${searchParams.toString()}`)
        }
      })
      .catch(error => {
        // Handle error if needed
      })
  }

  const handleSearch = () => {
    fetchPromotions(1)
  }

  const onPageChange = page => {
    fetchPromotions(page)
  }

  // useEffect(() => {
  //   if (isApiCalled) {
  //     const delayDebounceFn = setTimeout(() => {
  //       handleSearch()
  //     }, 500)

  //     return () => clearTimeout(delayDebounceFn)
  //   }
  // }, [searchTerm])

  // useEffect(() => {
  //   if (isApiCalled) {
  //     handleSearch()
  //   }
  // }, [selectedFilters])

  const handleEnablePromotion = (id, status) => {
    setSelectedId(id)
    startSensitiveAction({ kind: "STATUS", id, status })
  }

  const handleDelete = () => {
    const payload = {
      id: itemIdToDelete,
      status: "2", // 2 FOR DELETE
    }
    dispatch(deletePromotion(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setShowDeleteModal(false)
          setItemIdToDelete(null)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleReset = () => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: 1,
      status: 2,
      orderBy: 2,
      keyword: "",
    }
    dispatch(getAllPromotions(payload))

    setSelectedFilters({
      status: 2,
      sortOrder: 2,
    })
    setSearchTerm("")
    navigate(`/discounts?page=1`)
  }

  return (
    <div className="page-content">
      <SensitiveActionOtpModal {...modalProps} />
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col xl={12}>
            <Card>
              <DataExportDropdown
                cardTitle={t("Discounts List")}
                isAddBtn={loading ? false : usersPermissions.create}
                addBtnText={t("Add Discount")}
                onAddBtnClick={() => navigate("/discounts/add")}
              />
              <CardBody>
                <Filters
                  filters={filters}
                  searchTerm={searchTerm}
                  handleSearchChange={handleSearchChange}
                  handleFilterChange={handleFilterChange}
                  handleSearch={handleSearch}
                  onReset={handleReset}
                  selectedFilters={selectedFilters}
                  searchBy={t("Name")}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          {loading ? (
            <Row className="item_shimmer">
              {[1, 2, 3].map(item => (
                <React.Fragment key={item}>
                  <Col
                    lg={12}
                    className={`pe-0 first ${
                      item !== 1 && "promotion_shimmer"
                    }`}
                  >
                    <ShimmerSimpleGallery
                      card
                      imageHeight={100}
                      col={3}
                      row={2}
                    />
                  </Col>
                </React.Fragment>
              ))}
            </Row>
          ) : promotions.length === 0 ? (
            <p className="text-center my-2">{t("No discount found")}</p>
          ) : (
            promotions.map(({ _id, name, status, offerType, discountType }) => (
              <Col lg={4} key={_id}>
                <Card className="full_height_card">
                  <CardBody>
                    <div className="d-flex justify-content-between align-items-start">
                      <CardTitle className="in_2_line fs-6">{name}</CardTitle>
                      <div className="d-flex ">
                        {usersPermissions.edit && (
                          <Switch
                            onClickHandler={e => {
                              handleEnablePromotion(_id, status)
                            }}
                            isChecked={status === 1}
                            disabled={
                              isActionBusy ||
                              (_id === selectedId && isUpdating)
                            }
                          />
                        )}
                        <UncontrolledDropdown>
                          <DropdownToggle tag="a" className="card-drop">
                            <i className="mdi mdi-dots-vertical font-size-18"></i>
                          </DropdownToggle>

                          <DropdownMenu className="dropdown-menu-end">
                            {usersPermissions.edit && (
                              <DropdownItem
                                onClick={() => {
                                  navigate(`/discounts/edit?id=${_id}`)
                                }}
                              >
                                <i className="mdi mdi-pencil font-size-16 text-success me-1"></i>
                                {t("Edit")}
                              </DropdownItem>
                            )}

                            <DropdownItem
                              onClick={() => {
                                navigate(
                                  `/discounts/discount-details?id=${_id}`
                                )
                              }}
                            >
                              <i className="mdi mdi-eye font-size-16 text-primary me-1"></i>
                              {t("View")}
                            </DropdownItem>

                            {usersPermissions.delete && (
                              <DropdownItem
                                onClick={e => {
                                  setItemIdToDelete(_id)
                                  setShowDeleteModal(true)
                                }}
                              >
                                <i
                                  className="mdi mdi-trash-can font-size-16 text-danger me-1"
                                  id="deletetooltip"
                                ></i>
                                {t("Delete")}
                              </DropdownItem>
                            )}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    </div>
                    <div className="d-flex align-items-start">
                      <p style={{ fontWeight: 500, color: "#a2a2a2" }}>
                        {t("Offer Type")}:
                      </p>
                      <p className="mt-0 fw-bold mx-2 text-capitalize">
                        {t(offerType)}
                      </p>
                    </div>
                    <div className="d-flex">
                      <p style={{ fontWeight: 500, color: "#a2a2a2" }}>
                        {t("Discount Type")}:
                      </p>
                      <p className="mt-0 fw-bold mx-2 text-capitalize">
                        {t(discountType)}
                      </p>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))
          )}

          {!loading && (
            <div className="mt-3">
              <Card>
                <CardBody>
                  <Paginations
                    data={promotions}
                    itemsPerPage={itemsPerPage}
                    onPageChange={onPageChange}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalCount={totalCount}
                  />
                </CardBody>
              </Card>
            </div>
          )}
        </Row>
      </div>
      <DeleteModal
        show={showDeleteModal}
        isLoading={isLoading}
        onDeleteClick={handleDelete}
        onCloseClick={() => setShowDeleteModal(false)}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this {{name}}?", {
          name: t("Discount"),
        })}
      />
    </div>
  )
}

export default Promotions
